/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useNavigate } from 'react-router-dom';
import { Pathname } from 'Routes';
import styles from '../../index.module.css';

export const AlbumBanner = ({ layoutData, profileName, orderedData, layoutType, isPublicUser }) => {
  // eslint-disable-next-line no-script-url
  window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const navigate = useNavigate();
  const isTrueValue = true;
  const isFalseValue = false;
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  return (
    <div className={styles.albumBannerContainer}>
      <Carousel
        swipeable={isFalseValue}
        draggable={isFalseValue}
        showDots={isTrueValue}
        responsive={responsive}
        ssr={isTrueValue} // means to render carousel on server-side.
        infinite={layoutData?.length === 1 ? isFalseValue : isTrueValue}
        autoPlaySpeed={2000}
        customTransition="all .5"
        transitionDuration={500}
        containerClass={layoutData?.length !== 1 ? 'carousel-container-album-banner' : null}
        removeArrowOnDeviceType={['tablet', 'mobile']}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-albumbanner"
        autoPlay={isTrueValue}
        arrows={isFalseValue}
        partialVisible={layoutData?.length === 1 ? isFalseValue : isTrueValue}
      >
        {
          layoutData.map(({ thumbnail, title, id }) => (
            <>
              <img
                alt="Projector"
                className={styles.albumBannerImage}
                src={thumbnail}
                onClick={() => navigate(Pathname.getAlbumPath(id))}
              />
              <div className={styles.albumTitle}>{title}</div>
            </>
          ))
        }
      </Carousel>
    </div>
  );
};
